export default "__VITE_ASSET__rWkNWsLU__"